import { Link } from 'react-router-dom';
import type { VoteView } from '../api/missions';
import { ca } from '../i18n/ca';
import { VotesPanel } from './DecisionPanels';

/**
 * What an ended night of a campaign leaves to decide: the vote for the next chapter, which
 * the platform opens when the chapter closes (campaign `nextDecidedBy: vote`). While it is
 * open the options are the vote's own buttons; once closed the choice is said; with no vote
 * at all the card says so and leads to the campaign, where the chapter is made another way.
 * Nothing here is drawn for a night outside a campaign.
 */
export function NextChapterCard({
  campaignCode,
  code,
  votes,
  onVotes,
  onError,
}: {
  campaignCode: string;
  code: string;
  votes: VoteView[];
  onVotes: (votes: VoteView[]) => void;
  onError: (text: string | null) => void;
}) {
  const t = ca.sessionPage;
  const vote = votes.filter((v) => v.key === 'nextChapter').sort((a, b) => b.id - a.id)[0];
  return (
    <section className="cards" aria-label={t.nextChapterTitle}>
      <article className="card">
        <h2>{t.nextChapterTitle}</h2>
        {vote?.state === 'CLOSED' && vote.result ? (
          <p>{t.nextChapterChosen(vote.result)}</p>
        ) : !vote ? (
          <p className="muted small">{t.nextChapterEmpty}</p>
        ) : null}
        <Link className="button" to={`/c/${campaignCode}`}>
          <i className="bi bi-flag" aria-hidden="true" /> {t.nextChapterOpen}
        </Link>
      </article>
      {vote?.state === 'OPEN' && (
        <VotesPanel
          code={code}
          votes={[vote]}
          canDirect={false}
          onVotes={onVotes}
          onError={onError}
          live
        />
      )}
    </section>
  );
}
